import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { syncVendorSettings } from '../store/LabData/LabDataSlice';
import { vendorQueryOptions } from './fetchers/vendor';
import { unreadCountQueryOptions } from './fetchers/notifications';

/**
 * Prefetches shared shell data once for the authenticated layout:
 * - GET /api/vendor (vendor settings → Redux)
 * - GET /notifications/unread-count (shared React Query cache for NavBar)
 */
const ShellDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const vendorQuery = useQuery(vendorQueryOptions());

  useQuery(unreadCountQueryOptions());

  useEffect(() => {
    if (vendorQuery.data) {
      dispatch(syncVendorSettings(vendorQuery.data));
    }
  }, [vendorQuery.data, dispatch]);

  return children;
};

export default ShellDataProvider;
